import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/TeamsAndLabs/Header';
import MainContent from 'components/TeamsAndLabs/MainContent';

export default function TeamsAndLabs() {
  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>Easy to use Pharma Designs for Medical Communications</title>

        <meta
          key="description"
          name="description"
          content="Teams & Labs plan is suitable for pharmaceutical companies that need a professional tool to upgrade their designs with scientifically accurate illustrations."
        />
        <meta
          key="og:title"
          name="og:title"
          property="og:title"
          content="Easy to use Pharma Designs for Medical Communications"
        />
        <meta
          key="og:description"
          name="og:description"
          property="og:description"
          content="Teams & Labs plan is suitable for pharmaceutical companies that need a professional tool to upgrade their designs with scientifically accurate illustrations."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
